// extracted by mini-css-extract-plugin
export default {"privacyToggleWrapper":"PrivacyToggle_privacyToggleWrapper__3ErQw","privacyToggle":"PrivacyToggle_privacyToggle__IvgAc"};